export const OpenDcCampaignType = {
    display: "DISPLAY",
    video: "VIDEO",
    socialVideo: "SOCIAL_VIDEO",
    socialStatic: "SOCIAL_STATIC",
    tiktok: "TIKTOK",
} as const;
